import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=5a6396c6&scoped=true"
import script from "./NotificationDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&id=5a6396c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6396c6",
  null
  
)

export default component.exports